<div [formGroup]="singleSelectGroup" class="single-select-container">
    <ng-select
        [clearable]="clearable"
        [dropdownPosition]="'bottom'"
        [items]="mutableItems"
        [multiple]="false"
        [placeholder]="placeholder"
        [bindLabel]="bindLabel"
        [formControl]="selectedItemsControl"
        [title]="tooltip ? tooltip : ''"
    >
    </ng-select>
</div>
